module.exports = __webpack_public_path__ + "static/media/miracleCorrect.f1154fde.png";